export function normalizeListResponse(data) {
    if (Array.isArray(data)) {
        return {
            items: data,
            total: data.length,
            page: 1,
            limit: data.length || 1,
            counts: {},
        };
    }

    const items = Array.isArray(data?.items) ? data.items : [];
    return {
        items,
        total: Number(data?.total ?? items.length ?? 0),
        page: Number(data?.page ?? 1),
        limit: Number(data?.limit ?? (items.length || 1)),
        counts: data?.counts && typeof data.counts === "object" ? data.counts : {},
    };
}
